export default {
  allTimeIntervals: [],
}
